import { jwtDecode } from "jwt-decode";

export const getAuthToken = () => {
  return localStorage.getItem("token");
};

export const setAuthToken = (token: string | null) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const setRefreshToken = (token: string | null) => {
  if (token) {
    localStorage.setItem("refreshToken", token);
  } else {
    localStorage.removeItem("refreshToken");
  }
};

export const isTokenExpired = (token: string) => {
  try {
    const decoded: { exp: number } = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (e) {
    return true;
  }
};

export const extractApplicationIdFromToken = (token: string): string | null => {
  try {
    const decoded: { applicationId?: string; [key: string]: any } = jwtDecode(token);
    return decoded.applicationId || null;
  } catch (e) {
    return null;
  }
};

export const isValidJWTFormat = (token: string): boolean => {
  try {
    // Check if token has three parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) {
      return false;
    }

    // Try to decode the token
    jwtDecode(token);
    return true;
  } catch (error) {
    return false;
  }
};
